import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';
import { FiHome, FiMessageCircle, FiUser, FiLogOut, FiMenu, FiX } from 'react-icons/fi';
import NotificationBell from '../NotificationBell';
import '../../styles/topnav.css';

const navItems = [
  { path: '/user/dashboard', label: 'Mission Base', icon: <FiHome /> },
  { path: '/user/campaigns', label: 'My Outreach', icon: <FiMessageCircle /> },
  { path: '/user/profile', label: 'Profile', icon: <FiUser /> },
];

export default function UserLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const handleLogout = async () => {
    await logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  return (
    <div className="app-layout topnav-layout">
      <nav className="topnav user-topnav">
        {/* Brand */}
        <div className="topnav-brand" onClick={() => navigate('/user/dashboard')}>
          <img src="/Conquerlogo.png" alt="Logo" className="topnav-logo" />
          <div className="topnav-brand-text">
            <h1>Conquer</h1>
            <span>USER PANEL</span>
          </div>
        </div>

        {/* Mobile Toggle */}
        <button className="topnav-mobile-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? <FiX /> : <FiMenu />}
        </button>

        {/* Navigation Menu */}
        <ul className={`topnav-menu ${mobileMenuOpen ? 'open' : ''}`}>
          {navItems.map(item => (
            <li key={item.path} className="topnav-item">
              <NavLink to={item.path} className={({ isActive }) => `topnav-link ${isActive ? 'active' : ''}`}>
                {item.icon}
                <span>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Right Section */}
        <div className="topnav-right">
          <NotificationBell role="user" />
          <div className="topnav-user" onClick={() => navigate('/user/profile')}>
            <div className="topnav-avatar">{user?.username?.[0]?.toUpperCase()}</div>
            <div className="topnav-user-info">
              <span>{user?.username}</span>
              <small>{user?.role}</small>
            </div>
          </div>
          <button className="topnav-logout" onClick={handleLogout} title="Logout">
            <FiLogOut />
          </button>
        </div>
      </nav>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
